import { render, staticRenderFns } from "./ItemDetailsModal.vue?vue&type=template&id=679ec3dc&"
import script from "./ItemDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ItemDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports